import {AfterViewInit, ContentChild, Directive, HostListener, Injector, Optional} from '@angular/core';

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";
import {AnchorComponent} from "../../../../basic/anchor/anchor.component";
import {addClass, removeClass} from "@wm/core";

const DEFAULT_CLS = 'app-nav-item';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-nav-item',
  hostClass: DEFAULT_CLS
};

@Directive({
  selector: '[wmNavItem]',
  providers: [
  provideAsWidgetRef(NavItemDirective)
  ],
  standalone: true,
  exportAs: 'wmNavItem'
})
export class NavItemDirective extends StylableComponent{
  static initializeProps = register('wm-nav-item');
  public isAttached: boolean = false;
  @ContentChild(AnchorComponent) innerLink: any;

  constructor(inj: Injector, @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

  public ngOnDetach() {
    removeClass(this.nativeElement, 'active', true);
  }
}

